import React from 'react';
import { useTranslation } from 'react-i18next';
import { useOnlineStatus } from 'hooks/useOnlineStatus';
import './OfflineNotification.scss';

export const OfflineNotification = () => {
	const isOnline = useOnlineStatus();
	const { t } = useTranslation();
	if (isOnline) return null;

	return (
		<div className="offline-notification" role="status" aria-live="polite">
			<i className="pi pi-wifi" aria-hidden="true" />
			<span>{t('network.offline')}</span>
		</div>
	);
};
